var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6291 30.7461C61.6291 47.2488 48.251 60.627 31.7482 60.627C15.2455 60.627 1.86731 47.2488 1.86731 30.7461C1.86731 14.2433 15.2455 0.865234 31.7482 0.865234C48.251 0.865234 61.6291 14.2433 61.6291 30.7461Z",
    fill: "#50D05C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_32352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 61,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5099 32.6289C60.5099 49.1316 47.1317 62.5098 30.629 62.5098C14.1263 62.5098 0.748047 49.1316 0.748047 32.6289C0.748047 16.1261 14.1263 2.74805 30.629 2.74805C47.1317 2.74805 60.5099 16.1261 60.5099 32.6289Z",
    fill: "#1E70EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_32352)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.788857
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6531 -21.5488C24.6531 -21.5488 -4.94137 40.6793 -34.9936 40.5115C-35.758 40.5073 -5.34261 72.2312 -5.34261 72.2312C-5.34261 72.2312 51.1707 65.3418 48.0981 -10.5159C47.7689 -18.6426 24.6531 -21.5488 24.6531 -21.5488Z",
    fill: "#C4D1FF",
    fillOpacity: 0.3
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5566 30.7969L27.3165 39.5569L44.9379 21.9355",
    stroke: "white",
    strokeWidth: 4.74072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.08790387d6c821b6d82533f3bf95c52a.svg";
export { ForwardRef as ReactComponent };